export const discoveryMoc = {
    title: 'Quem é Luiz Gregatti e Fly Educacional?',
    text: 'CEO e Fundador da Agência Home Office e Fly educacional, acumulamos nos últimos 3 anos de existência mais de 38 mil clientes e + 20 Milhões faturados.',
}
